import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  // URL: 'http://localhost/open_house/api/',
  URL: 'https://openhouse.rmutl.ac.th/api/',
  isLoading: false,
  screenWidth: 375,
  user: {
    userId: '',
    citizenId: '',
    fullname: '',
    email: '',
    tel: '',
    school: '',
    facId: '',
    facName: '',
    depName: ''
  }
}

const store = new Vuex.Store({
  state
})

export default store



// WEBPACK FOOTER //
// ./src/vuex/index.js